// extracted by mini-css-extract-plugin
export default {"infoContainer":"NoAccessAcademy_infoContainer__ZnIqB","noAccessContainer":"NoAccessAcademy_noAccessContainer__DQzpK"};